'use client';

import { useGraphEndpoint } from '@squareup/dex-feature-hooks-graph';
import { FeedbackWidget } from '@squareup/dex-ui';
import { useApiExplorerFeedbackContext } from '@squareup/dex-ui-shared-api-explorer-providers';
import {
  ROUTER_NOT_READY,
  usePathname,
} from '@squareup/dex-utils-shared-routing-hooks';
import React, { useCallback } from 'react';

interface Props {
  componentId: number;
}

const PromptFeedbackWidgetWrapper: React.FC<Props> = React.memo(
  ({ componentId }) => {
    const { pathName, isReady } = usePathname();
    const currentPathName = isReady ? pathName : ROUTER_NOT_READY;

    const { endpoint } = useGraphEndpoint();
    const { showFeedbackPrompt, resetUserEndpointCount } =
      useApiExplorerFeedbackContext();

    const onFeedbackSubmitted = useCallback(
      (event: CustomEvent) => {
        if (endpoint?.id) {
          if (
            event.detail.lastResponseDate &&
            event.detail.lastResponseDate instanceof Date
          ) {
            resetUserEndpointCount(
              endpoint.id,
              event.detail.lastResponseDate.toISOString()
            );
          } else {
            resetUserEndpointCount(endpoint.id);
          }
        }
      },
      [endpoint?.id, resetUserEndpointCount]
    );

    return (
      <FeedbackWidget
        componentId={componentId}
        subcomponentId={currentPathName}
        floating={true}
        showPrompt={showFeedbackPrompt}
        onComponentSubmitted={onFeedbackSubmitted}
      />
    );
  }
);

PromptFeedbackWidgetWrapper.displayName = 'PromptFeedbackWidgetWrapper';

export { PromptFeedbackWidgetWrapper };
